import { render, staticRenderFns } from "./popup-update-log.vue?vue&type=template&id=1d7f34a2&scoped=true"
import script from "./popup-update-log.vue?vue&type=script&lang=js"
export * from "./popup-update-log.vue?vue&type=script&lang=js"
import style0 from "./popup-update-log.vue?vue&type=style&index=0&id=1d7f34a2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d7f34a2",
  null
  
)

export default component.exports